/** Phase 3A.6C — group-aware route UI (default OFF, legacy UI unchanged). */
let routeGroupUiFlagLogged = false;

export function isRouteGroupUiEnabled(): boolean {
  const raw = process.env.REACT_APP_ROUTE_GROUP_UI_ENABLED;
  const enabled = String(raw || '').toLowerCase() === 'true';
  if (process.env.NODE_ENV === 'development' && !routeGroupUiFlagLogged) {
    routeGroupUiFlagLogged = true;
    // eslint-disable-next-line no-console
    console.log('[PHASE 3A.6C audit] REACT_APP_ROUTE_GROUP_UI_ENABLED raw =', raw, '| parsed =', enabled);
  }
  return enabled;
}

export function isRouteApplicationGroupsEnabled(): boolean {
  return String(process.env.REACT_APP_ROUTE_APPLICATION_GROUPS_ENABLED || '').toLowerCase() === 'true';
}

export function isRouteGroupValidationEnabled(): boolean {
  return (
    isRouteApplicationGroupsEnabled() &&
    String(process.env.REACT_APP_ROUTE_GROUP_VALIDATION_ENABLED || '').toLowerCase() === 'true'
  );
}

/** Phase 1D-B — scoped inbox rows (default OFF; legacy inbox rows unchanged). */
export function isRouteGroupDocumentWorkflowEnabled(): boolean {
  return String(process.env.REACT_APP_ROUTE_GROUP_DOCUMENT_WORKFLOW_ENABLED || '').toLowerCase() === 'true';
}
